module.exports = __webpack_public_path__ + "static/img/detail_ninjetownbanners_02.0a6574b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/ninjatown-banner-campaign/detail_ninjetownbanners_02.jpg
// module id = 264
// module chunks = 2